export const router = {
  home: '/',
  login: '/log-in',
  signup: process.env.REACT_APP_SIGN_UP_ROUTE,
};
